<template>
  <div class="wrapper box_v">
    <!--头部-->
    <page-head title="预约办理详情" :btn-list="btnList" @handleBtn="handleBtn"></page-head>
    <div class="box_f1 box_v card-box">
      <Card dis-hover :padding="20">
        <div class="detail-card box">
          <Spin fix v-if="detailLoading"></Spin>
          <div class="img-wrapper">
            <img :src="info.pic" />
          </div>
          <div class="event-info">
            <div class="event-name">{{info.eventName}}</div>
            <div class="event-type">{{info.eventType}}</div>
            <div class="box">
              <div style="width: 300px">
                <div class="appointment-count box">
                  <div class="event-title">预约次数</div>
                  <div>{{info.appointmentCount}}</div>
                </div>
                <div class="process-count box">
                  <div class="event-title">成功办理</div>
                  <div>{{info.processCount}}</div>
                </div>
                <div class="score-count box">
                  <div class="event-title">评分</div>
                  <Rate show-text allow-half disabled v-model="info.avgScore">
                    <div style="color: #ffaf00;font-size: 16px;height: 20px">{{info.avgScore}}</div>
                  </Rate>
                </div>
              </div>
              <div>
                <div class="box">
                  <i class="info-title">预约时间</i>
                  <div>
                    <div
                      v-for="item in info.timeList"
                      class="info-value mar-btm20"
                    >{{item.beginWeek}} 至 {{item.endWeek}} {{item.beginTime}}-{{item.endTime}} 限制:<span class="text">{{item.limit}}</span>人</div>
                  </div>
                </div>
                <div class="box" v-if="tmentDate.length >0">
                  <i class="info-title">特殊日期</i>
                  <div>
                    <div
                      v-for="item in tmentDate"
                      class="info-value mar-btm20"
                    >{{item.startDate}} 至 {{item.endDate}}
                  </div></div>
                </div>
                <div class="mar-btm20">
                  <i class="info-title">办理地点</i>
                  <i class="info-value">{{info.address}}</i>
                </div>
                <div class="mar-btm20">
                  <i class="info-title">预约电话</i>
                  <i class="info-value">{{info.phone}}</i>
                </div>
                <div class="box mar-btm20" style="align-items: center">
                  <i class="info-title">携带资料</i>
                  <Button class="btn" type="primary" @click="showRemark = true">携带资料</Button>
                </div>
                <div class="box slh" style="align-items: center">
                  <i class="info-title">备注</i>
                  <div class="info-value memo slh" :title="info.appointmentRemark">{{info.appointmentRemark}}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Card>
      <Card dis-hover :padding="0" class="box_f1" style="margin-top: 20px">
        <div class="box_v" style="height: 100%;">
          <div class="card-head box">
            <div>预约记录</div>
            <div>
              <Button
                v-for="(item,index) in headBtn"
                class="bkcc-btn"
                @click="handleBtn(item.type)"
              >{{item.name}}</Button>
            </div>
          </div>
          <div class="search-box box_f1" style="position: relative;">
            <i-form ref="formInline" inline label-position="top">
              <row :gutter="80">
                <i-col span="6">
                  <FormItem label="预约人" prop="host">
                    <Input v-model="appointmentPeople" />
                  </FormItem>
                </i-col>
                <i-col span="6">
                  <FormItem label="联系电话" prop="host">
                    <Input v-model="appointmentPhone" />
                  </FormItem>
                </i-col>
              </row>
              <row :gutter="80">
                <i-col span="6">
                  <FormItem label="预约日期" prop="host">
                    <DatePicker type="date" v-model="appointmentDate"></DatePicker>
                  </FormItem>
                </i-col>
                <i-col span="6">
                  <FormItem label="预约时间" prop="host">
                    <TimePicker v-model="appointmentTime" type="timerange"></TimePicker>
                  </FormItem>
                </i-col>
                <i-col span="6">
                  <FormItem label="办理状态" prop="host">
                    <Select v-model="banliStatus">
                      <Option
                        v-for="item in statusList"
                        :value="item.value"
                        :key="item.value"
                      >{{ item.label }}</Option>
                    </Select>
                  </FormItem>
                </i-col>
              </row>
            </i-form>
            <Table
              stripe
              border
              :columns="settingColumn"
              :data="appointmentList"
              :loading="isTableLoading"
              @on-select="selectTableItem"
              @on-select-cancel="cancelTableItem"
            ></Table>
            <page
              :total="total"
              @on-change="pageChange"
              class="page"
              :page-size="rows"
              :current="page"
              show-total
            />
          </div>
        </div>
      </Card>
    </div>
    <Modal
      v-model="showRemark"
      title="携带资料"
      :mask-closable="false"
      width="600"
      @on-ok="showRemark = false"
      @on-cancel="showRemark = false"
    >
      <div class="remark-wrapper">
        <p v-html="info.remark"></p>
      </div>
    </Modal>
    <opinion-modal
      :show-modal="showOpinion"
      @closeOpinion="showOpinion = false"
      @confirmCancel="confirmCancel"
    ></opinion-modal>
    <detail-modal :show-modal="showDetail" @closeOpinion="showDetail = false" :id="showItemId"></detail-modal>
  </div>
</template>

<script>
import pageHead from "../../components/head";
import util from "../../utils/util";
import opinionModal from "./appointComponents/opinionModal";
import detailModal from "./appointComponents/detailModal";

var that;
export default {
  name: "appointmentDetail",
  components: {
    pageHead,
    opinionModal,
    detailModal
  },
  data() {
    return {
      id: "",
      status: "",
      info: {},
      tmentDate:[],
      showRemark: false,
      detailLoading: false,
      headBtn: [
        {
          name: "搜索",
          type: "search",
          loading: false
        },
        {
          name: "重置",
          type: "init",
          loading: false,
          btnType: "default"
        },
        {
          name: "办理",
          type: "banli",
          loading: false,
          btnType: "default"
        },
        {
          name: "取消预约",
          type: "cancel",
          loading: false,
          btnType: "default"
        }
      ],
      statusList: [
        {
          label: "已预约",
          value: 1,
          color: "#00d372"
        },
        {
          label: "逾期未办",
          value: 2,
          color: "#5e6d9e"
        },
        {
          label: "居民取消办理",
          value: 4,
          color: "#cfc800"
        },
        {
          label: "管理员取消预约",
          value: 8,
          color: "#cf6aff"
        },
        {
          label: "待评价",
          value: 16,
          color: "#ffaf00"
        },
        {
          label: "已办结",
          value: 32,
          color: "#8cc64e"
        }
      ],
      appointmentPeople: "",
      appointmentPhone: "",
      appointmentDate: "",
      appointmentTime: [],
      banliStatus: "",
      page: 1,
      rows: 5,
      appointmentList: [],
      isTableLoading: false,
      settingColumn: [
        {
          type: "selection",
          width: 70,
          align: "center"
        },
        {
          title: "预约人",
          key: "name",
          align: "center",
          width: 105
        },
        {
          title: "联系电话",
          key: "phone",
          width: 180
        },
        {
          title: "身份证号",
          key: "cardNO",
          width: 220
        },
        {
          title: "预约日期",
          key: "appointmentDate"
        },
        {
          title: "预约时间",
          key: "appointmentTime"
        },
        {
          title: "事项类型",
          key: "eventType"
        },
        {
          title: "事项名称",
          key: "eventName"
        },
        {
          title: "办理状态",
          width: 200,
          render: function(h, params) {
            return h("div", [
              h(
                "span",
                {
                  style: {
                    color: that.statusList.filter(
                      item =>
                        item.value == that.appointmentList[params.index].status
                    )[0].color,
                    display:
                      that.appointmentList[params.index].status == 32
                        ? "none"
                        : ""
                  }
                },
                that.appointmentList[params.index].statusName
              ),
              h("Rate", {
                style: {
                  display:
                    that.appointmentList[params.index].status == 32
                      ? ""
                      : "none"
                },
                attrs: {
                  disabled: true,
                  allowHalf: true,
                  value: that.appointmentList[params.index].score
                }
              })
            ]);
          }
        },
        {
          title: "操作",
          width: 240,
          render: function(h, params) {
            var status = that.appointmentList[params.index].status;
            return h("div", [
              h(
                "span",
                {
                  style: {
                    color: "#5e6d94",
                    display: status == 1 || status == 2 ? "" : "none",
                    marginRight: "10px"
                  },
                  on: {
                    click: e => {
                      e.stopPropagation();
                      that.selectPeople = that.appointmentList[params.index].id;
                      that.showOpinion = true;
                    }
                  }
                },
                "[取消预约]"
              ),
              h(
                "span",
                {
                  style: {
                    color: "#5e6d94",
                    marginRight: "10px",
                    display: status == 1 || status == 2 ? "" : "none"
                  },
                  on: {
                    click: e => {
                      e.stopPropagation();
                      that.changeUserAppointment(
                        that.appointmentList[params.index].id,
                        16
                      );
                    }
                  }
                },
                "[办理]"
              ),
              h(
                "span",
                {
                  style: {
                    color: "#5e6d94",
                    display: status == 1 || status == 2 ? "none" : ""
                  },
                  on: {
                    click: e => {
                      e.stopPropagation();
                      that.showItemId = that.appointmentList[params.index].id;
                      that.showDetail = true;
                      // that.editItem(params.index)
                    }
                  }
                },
                "[查看办理信息]"
              )
            ]);
          }
        }
      ],
      selectAppointment: [],
      showOpinion: false,
      selectPeople: "",
      total: 0,
      showDetail: false,
      showItemId: ""
    };
  },
  computed: {
    btnList() {
      console.log(this.status);
      if (this.status == 1) {
        return [
          {
            name: "暂停预约",
            type: "stop",
            loading: false
          },
          {
            name: "编辑",
            type: "edit",
            loading: false,
            btnType: "default"
          }
        ];
      } else {
        return [
          {
            name: "开通预约",
            type: "start",
            loading: false
          },
          {
            name: "编辑",
            type: "edit",
            loading: false,
            btnType: "default"
          }
        ];
      }
    }
  },
  methods: {
    getDetail() {
      this.detailLoading = true;
      this.$get(this.urlobj.getAppointmentDetail(this.id)).then(res => {
        this.detailLoading = false;
        var info = res.rows[0];
        console.log(info);
        this.info = {
          pic: info.headPicUrl,
          eventType: info.eventType,
          eventTypeId: info.eventTypeId,
          eventName: info.eventName,
          eventNameId: info.eventNameId,
          appointmentCount: info.appointmentCount,
          processCount: info.processCount,
          appointmentRemark: info.appointmentRemark,
          avgScore: info.avgScore
            ? parseFloat((info.avgScore / 100).toFixed(1))
            : 0,
          timeList: info.timeList.map(item => {
            return {
              beginWeek: util.handelWeek(item.beginWeek),
              endWeek: util.handelWeek(item.endWeek),
              beginTime: item.beginTime.slice(0, 5),
              endTime: item.endTime.slice(0, 5),
              limit: item.limitCount
            };
          }),
          address: info.address,
          phone: info.phoneNO,
          remark: info.remark
        };
      });
    },
    getTmentDate() {
      this.tmentDate = []
      this.$post(this.urlobj.getTmentDate, {
        appointmentId: this.id,
        pageNum: 1,
        pageSize: 1000
      }).then(res => {
        if (res.isSucceed) {
          this.tmentDate = res.rows
        }
      })
    },
    handleBtn(type) {
      if (type == "stop" || type == "start") {
        this.changeStatus();
      } else if (type == "edit") {
        this.$router.push({ name: "appointmentEdit", query: { id: this.id } });
      } else if (type == "search") {
        this.page = 1;
        this.getAppointmentUser();
      } else if (type == "init") {
        this.appointmentDate = "";
        this.banliStatus = "";
        this.appointmentPeople = "";
        this.appointmentPhone = "";
        this.appointmentTime = [];
        this.getAppointmentUser();
      } else if (type == "banli") {
        if (!this.selectAppointment.length) {
          this.$Message.warning("未选择人员");
          return;
        }
        var idList = this.selectAppointment.map(item => item.id).join(",");

        this.changeUserAppointment(idList, 16);
      } else if (type == "cancel") {
        if (!this.selectAppointment.length) {
          this.$Message.warning("未选择人员");
          return;
        }
        this.selectPeople = "";
        this.showOpinion = true;
      }
    },
    // 改变预约状态
    changeStatus() {
      this.$post(this.urlobj.changeAppointmentStatus, {
        idList: this.id,
        status: this.status == 1 ? 2 : 1
      }).then(res => {
        this.$Message.success("操作成功");
        this.status = this.status == 1 ? 2 : 1;
        console.log(this.status);
      });
    },
    getAppointmentUser() {
      this.isTableLoading = true;
      let {
        page,
        rows,
        id,
        info,
        appointmentDate,
        banliStatus,
        appointmentPeople,
        appointmentPhone,
        appointmentTime
      } = this;
      var appointmentBeginTime = "",
        appointmentEndTime = "";
      if (appointmentTime.length) {
        appointmentBeginTime = appointmentTime[0];
        appointmentEndTime = appointmentTime[1];
      }
      this.$post(this.urlobj.getAppointmentUser, {
        pageNum: page,
        pageSize: rows,
        appointmentId: id,
        eventTypeId: info.eventTypeId,
        eventNameId: info.eventNameId,
        appointmentDate: appointmentDate
          ? this.$util.FormatDate(new Date(appointmentDate), "yyyy-MM-dd")
          : "",
        appointmentBeginTime,
        appointmentEndTime,
        status: banliStatus,
        userName: appointmentPeople,
        phoneNO: appointmentPhone
      }).then(res => {
        this.isTableLoading = false;
        this.total = res.total;
        this.appointmentList = res.rows.map(item => {
          var _checked = false;
          this.selectAppointment.forEach(_item => {
            if (_item.id == item.id) {
              _checked = true;
            }
          });
          return {
            id: item.id,
            name: item.realName,
            phone: item.phoneNO,
            cardNO: item.idCardNO,
            appointmentDate: item.appointmentDate,
            appointmentTime:
              item.appointmentBeginTime.slice(0, 5) +
              "-" +
              item.appointmentEndTime.slice(0, 5),
            eventType: item.eventType,
            eventName: item.eventName,
            status: item.status,
            statusName: this.statusList.filter(
              _item => _item.value == item.status
            )[0].label,
            _checked,
            score: item.score ? parseFloat((item.score / 100).toFixed(1)) : 5
          };
        });
        console.log(this.appointmentList);
      });
    },
    selectTableItem(value) {
      this.selectAppointment = this._.unionBy(
        this.selectAppointment,
        value,
        "id"
      );
    },
    cancelTableItem() {
      var value = arguments[1];
      var delIndex;
      this.selectAppointment.forEach((item, index) => {
        if (item.id == value.id) delIndex = index;
      });
      this.selectAppointment.splice(delIndex, 1);
    },
    confirmCancel(reason) {
      var idList;
      if (this.selectPeople) idList = this.selectPeople;
      else idList = this.selectAppointment.map(item => item.id).join(",");
      this.changeUserAppointment(idList, 8, reason);
    },
    changeUserAppointment(idList, status, cancelMsg = "") {
      this.$post(this.urlobj.changeUserAppointment, {
        idList,
        status,
        cancelMsg
      })
        .then(res => {
          this.$Message.success("操作成功");
          this.showOpinion = false;
          this.getAppointmentUser();
        })
        .catch(e => {});
    },
    pageChange(val) {
      this.page = val;
      this.getAppointmentUser();
    }
  },
  mounted() {
    that = this;
    this.id = this.$route.query.id;
    this.status = this.$route.query.status;
    this.eventNameId = this.$route.query.eventNameId;
    this.getDetail();
    this.getTmentDate()
    this.getAppointmentUser();
  }
};
</script>

<style scoped lang="less">
/deep/ .ivu-form .ivu-form-item-label {
  font-size: 16px;
}

/deep/ .ivu-form-inline .ivu-form-item {
  display: block;
}

/deep/ .ivu-date-picker {
  display: block;
}

/deep/ .ivu-card-body {
  height: 100%;
}

.wrapper {
  height: 100%;
}

.memo {
  width: 800px;
}
.btn {
  min-width: 60px;
  height: 28px;
  line-height: 13px;
  display: block;
}
.text {
  display: inline-block;
  width: 25px;
  text-align: right;
}
.card-box {
  margin: 0 20px 20px;
}

.mar-btm20 {
  margin-bottom: 20px;
}

.detail-card {
  position: relative;
  .img-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 120px;
    width: 120px;
    background: #f1f1f1;
    border-radius: 7px;
    margin-right: 20px;
    img {
      width: 50px;
      height: 50px;
      display: block;
    }
  }
  .event-info {
    line-height: 1;
    color: #4b4b4b;
    font-size: 16px;
    .event-name {
      font-size: 17px;
      margin-bottom: 10px;
    }
    .event-type {
      color: #ff7b44;
      font-size: 15px;
      margin-bottom: 25px;
    }
    .appointment-count {
      margin-bottom: 15px;
    }
    .process-count {
      margin-bottom: 15px;
    }
    .event-title {
      width: 65px;
      margin-right: 20px;
      text-align: right;
    }
    .info-title {
      margin-right: 20px;
    }
    .info-value {
      color: #999;
    }
  }
}

.remark-wrapper {
  height: 300px;
  overflow-y: scroll;
}

.remark-wrapper::-webkit-scrollbar {
  display: none;
}

.card-head {
  padding: 0 20px;
  height: 60px;
  align-items: center;
  justify-content: space-between;
  font-size: 16px;
  border-bottom: 1px solid #ddd;
}

.search-box {
  padding: 20px 20px 80px;
}

.page {
  position: absolute;
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%);
}
</style>
